import { create } from 'zustand'

const useStore = create((set, get) => ({
  // Filters state
  filters: {
    produits: [],           // Maps to designation_commercial
    importateurs: [],       // Maps to nom_raison_sociale  
    fournisseurs: [],       // Maps to fournisseur
    nif_importateur: [],
    pays_origine: [],
    incoterm: [],
    code_regime_apc: [],
    date_debut: null,
    date_fin: null,
    annee_declaration: [],
  },
  
  // Data state
  data: {
    kpi: null,
    timeseries: null,
    top_produits: null,
    top_importateurs: null,
    top_fournisseurs: null,
    table: null,
  },
  
  // UI state
  loading: false,
  hasFilters: false,
  error: null,
  
  // Filter options cache
  filterOptions: {
    produits: [],           // Maps to designation_commercial
    importateurs: [],       // Maps to nom_raison_sociale
    fournisseurs: [],       // Maps to fournisseur
    nif_importateur: [],
    pays_origine: [],
    incoterm: [],
    code_regime_apc: [],
  },
  
  // Actions
  setFilters: (newFilters) => {
    const hasAnyFilter = Object.values(newFilters).some(value => {
      if (Array.isArray(value)) return value.length > 0
      return value !== null && value !== undefined && value !== ''
    })
    
    set({ 
      filters: newFilters,
      hasFilters: hasAnyFilter
    })
  },
  
  updateFilter: (filterName, value) => {
    const currentFilters = get().filters
    const newFilters = { ...currentFilters, [filterName]: value }
    get().setFilters(newFilters)
  },
  
  clearFilters: () => {
    const emptyFilters = {
      produits: [],
      importateurs: [],
      fournisseurs: [],
      nif_importateur: [],
      pays_origine: [],
      incoterm: [],
      code_regime_apc: [],
      date_debut: null,
      date_fin: null,
      annee_declaration: [],
    }
    set({ 
      filters: emptyFilters,
      hasFilters: false,
      data: {
        kpi: null,
        timeseries: null,
        top_produits: null,
        top_importateurs: null,
        top_fournisseurs: null,
        table: null,
      }
    })
  },
  
  setData: (newData) => set({ data: newData }),
  
  setLoading: (loading) => set({ loading }),
  
  setError: (error) => set({ error }),
  
  setFilterOptions: (filterType, options) => {
    // S'assurer que options est toujours un tableau
    let safeOptions = []
    
    if (Array.isArray(options)) {
      safeOptions = options
    } else if (options && Array.isArray(options.options)) {
      safeOptions = options.options
    } else if (options && typeof options === 'object') {
      // Si c'est un objet avec des propriétés, essayer de le convertir
      safeOptions = Object.entries(options).map(([key, value]) => ({
        value: key,
        label: value || key,
        count: 0
      }))
    }
    
    set(state => ({
      filterOptions: {
        ...state.filterOptions,
        [filterType]: safeOptions
      }
    }))
  },
  
  // Computed values
  getActiveFiltersCount: () => {
    const filters = get().filters
    let count = 0
    
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) count++
      else if (value !== null && value !== undefined && value !== '') count++
    })
    
    return count
  },
  
  getFilterSummary: () => {
    const filters = get().filters
    const summary = []
    
    if (filters.produits?.length > 0) {
      summary.push(`${filters.produits.length} produit${filters.produits.length > 1 ? 's' : ''}`)
    }
    if (filters.importateurs?.length > 0) {
      summary.push(`${filters.importateurs.length} importateur${filters.importateurs.length > 1 ? 's' : ''}`)
    }
    if (filters.fournisseurs?.length > 0) {
      summary.push(`${filters.fournisseurs.length} fournisseur${filters.fournisseurs.length > 1 ? 's' : ''}`)
    }
    if (filters.pays_origine?.length > 0) {
      summary.push(`${filters.pays_origine.length} pays`)
    }
    if (filters.date_debut || filters.date_fin) {
      summary.push('période définie')
    }
    
    return summary.join(', ')
  }
}))

export default useStore
